module.exports = __webpack_public_path__ + "img/8.98dab8bd.jpg";